var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrRightGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5208 19.8633C33.4788 27.8215 41.437 35.7795 49.3949 43.7375C50.0261 44.3687 50.0261 45.6312 49.3949 46.2625L25.5208 70.1366C24.8264 70.8309 24.8263 71.9672 25.5208 72.6616L30.5379 77.6788C31.2324 78.3733 32.3686 78.3733 33.0629 77.6788L64.4792 46.2625C65.1736 45.568 65.1736 44.4319 64.4792 43.7375L33.0629 12.3212C32.3684 11.6267 31.2323 11.6267 30.5379 12.3212L25.5208 17.3383C24.8266 18.0325 24.8263 19.1689 25.5208 19.8633Z",
    fill: "#aaa"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrRightGray);
export default __webpack_public_path__ + "static/media/arr-right-gray.223ce3081faf5cd3c2ac521b0a53f4eb.svg";
export { ForwardRef as ReactComponent };